<template>
  <div>
    <div @click="openLink">
      <img
          class="document"
          :src="`${publicPath}/icons/black-file-icon.svg`"
      />
    </div>
  </div>
</template>

<script>
import constants from "@/util/constants";

export default {
  name: 'ChatAttachedS3Message',
  props: {
    document: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      openFile: false,
      publicPath: constants.isDevelopment ? '' : '',
      paper: '<s3-paper>',
      closedPaper: '</s3-paper>',
    }
  },
  methods: {
    openLink() {
      window.open(this.document.split(this.closedPaper)[1], '_blank');
    }
  },
};
</script>

<style scoped>
.document {
  height: 40px;
  border-radius: 5px;
}

.document:hover {
  border: solid 2px #00a1fb;
}
</style>
